export default __webpack_public_path__ + "static/media/atm-9.d4516f9f.png";